export default __webpack_public_path__ + "static/media/banner.49841fde.png";